import React from "react";
import {Tooltip} from "antd";
import {createSentimentTooltip} from "./tooltipFactory";
import {OriginBar} from "./OriginBar";
import {longColour, shortColour} from "../../../../style/styleConsts";

const isNotAvailable = (s) => s === null;

export const SentimentChart = (props) => {
    if (isNotAvailable(props.sentimentChange)) {
        return <div className="t-sentiment-container"/>;
    }
    const describeSentimentChangeOverTimePeriod = createSentimentTooltip(props.timePeriodName);
    return <Tooltip
        title={describeSentimentChangeOverTimePeriod(props.averageSentiment * 100, props.currentSentiment * 100)}
        mouseLeaveDelay={0}>
        <div className="t-sentiment-container"
             style={{width: 100, height: 10, position: "relative", display: "flex"}}>
            <OriginBar/>
            <div style={{width: "50%"}}>
                {props.sentimentChange < 0 ? <div className="t-sentiment" style={{
                    transition:      "width 0.3s",
                    width:           Math.min(100, -100 * props.sentimentChange / 25).toFixed() + "%",
                    height:          10,
                    opacity:         0.5,
                    backgroundColor: shortColour,
                    float:           "right"
                }}/> : null}
            </div>
            <div style={{width: "50%"}}>
                {props.sentimentChange > 0 ? <div className="t-sentiment" style={{
                    transition:      "width 0.3s",
                    width:           Math.min(100, 100 * props.sentimentChange / 25).toFixed() + "%",
                    height:          10,
                    opacity:         0.5,
                    backgroundColor: longColour
                }}/> : null}
            </div>
        </div>
    </Tooltip>
};